"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const LocationAside = ({ className = `ontario-medium-4`, children }) => {
    return ((0, jsx_runtime_1.jsx)("aside", Object.assign({ className: `ontario-small-12 ${className} ontario-columns` }, { children: children })));
};
exports.default = LocationAside;
